import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiAlertCircle, FiCheckCircle, FiClock, FiChevronRight, FiActivity, FiUser } = FiIcons;

const CaregiverPatientList = ({ onSelectPatient }) => {
  const [patients] = useState([
    { id: 1, name: 'Sarah Johnson', risk: 'critical', status: 'Heart Rate Spike', lastSync: '1m ago', mood: 'Agitated' },
    { id: 2, name: 'Michael Chen', risk: 'moderate', status: 'Sleep Deficit', lastSync: '15m ago', mood: 'Stable' },
    { id: 3, name: 'Emma Davis', risk: 'low', status: 'All Systems Nominal', lastSync: '2m ago', mood: 'Positive' }
  ]);

  const getRiskStyles = (risk) => {
    switch (risk) {
      case 'critical': return 'border-red-500 bg-red-50 text-red-700';
      case 'moderate': return 'border-orange-400 bg-orange-50 text-orange-700';
      default: return 'border-emerald-400 bg-emerald-50 text-emerald-700';
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-black text-gray-900 uppercase tracking-tight">Active Roster</h3>
        <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">{patients.length} Monitored</span>
      </div>

      {patients.map((patient) => (
        <motion.button
          key={patient.id}
          whileHover={{ x: 8 }}
          onClick={() => onSelectPatient(patient)}
          className={`w-full p-6 rounded-[2rem] border-2 transition-all text-left flex items-center justify-between ${getRiskStyles(patient.risk)}`}
        >
          <div className="flex items-center space-x-5">
            <div className="w-14 h-14 rounded-2xl bg-white flex items-center justify-center shadow-sm relative">
              <SafeIcon icon={FiUser} className="text-xl" />
              <div className={`absolute -top-1 -right-1 w-4 h-4 rounded-full border-2 border-white ${patient.risk === 'critical' ? 'bg-red-500 animate-pulse' : 'bg-green-500'}`} />
            </div>
            <div>
              <h4 className="font-black text-gray-900">{patient.name}</h4>
              <div className="flex items-center space-x-3 mt-1">
                <span className="text-[10px] font-black uppercase tracking-widest opacity-60 flex items-center">
                  <SafeIcon icon={FiActivity} className="mr-1" /> {patient.status}
                </span>
                <span className="text-[10px] font-black uppercase tracking-widest opacity-60 flex items-center border-l border-current/20 pl-3">
                  <SafeIcon icon={FiClock} className="mr-1" /> {patient.lastSync}
                </span>
              </div>
            </div>
          </div>
          <SafeIcon icon={FiChevronRight} className="text-xl opacity-40" />
        </motion.button>
      ))}
    </div>
  );
};

export default CaregiverPatientList;